<template>
  <div>
    <h1 class="h3 mb-3 text-gray-800">
      {{ $t("Agenda de Atendimentos") }}
    </h1>

    <div
      v-if="pessoa"
      class="alert alert-success alert-dismissible fade show shadow text-dark"
      role="alert"
    >
      <strong class="font-size-19">
        Usuário/Família cadastrada com sucesso!
      </strong>
      <table class="mt-2 mb-0">
        <tbody>
          <tr>
            <td class="pr-3 pt-2 border-0">
              <strong>
                {{
                  (pessoa?.nome_social)
                    ? pessoa?.nome_social
                    : pessoa?.nome_completo
                }}
              </strong>
              <b-link
                :to="'/dashboard/familias/edit/' + pessoa.id"
                target="_blank"
                :title="$t('Ver Prontuário Familiar')"
                v-b-tooltip.hover
              >
                <i class="fas fa-external-link-alt"></i>
              </b-link>
              <span v-if="pessoa?.nome_social">
                <br />
                ( N.R.: )
                <a v-if="!showName" href="#" @click.prevent="showName = true"><i class="fas fa-eye"></i></a>
                <span v-if="showName">
                  <strong> {{ pessoa?.nome_completo }} </strong>
                  <a href="#" @click.prevent="showName = false" ><i class="fas fa-eye-slash"></i></a>
                </span>
              </span>
              <br />
              <small class="text-muted">
                Idade: {{ pessoa.responsavel_familiar_idade }}
              </small>
            </td>
            <td class="pr-3 pt-2 pl-3 border-0">
              <span>
                ID Familiar:
                <strong> {{ pessoa.id }} </strong>
              </span>
            </td>
            <td class="pr-3 pt-2 pl-3 border-0">
              <span>
                Família Cadastrada:
                <strong> {{ pessoa.data_cadastramento }} </strong>
              </span>
            </td>
            <td class="pr-3 pt-2 pl-3 border-0" v-if="!pessoa.situacao_rua">
              <span>
                Endereço:
                <strong> {{ pessoa.endereco.logradouro }} </strong>
              </span>
            </td>
            <td class="pr-3 pt-2 pl-3 border-0" v-else>
              <b-icon
                icon="exclamation-triangle-fill"
                v-if="pessoa.situacao_rua"
                variant="warning"
                animation="fade"
              >
              </b-icon>
              Pessoa em situação de rua:
              <strong> {{ pessoa.situacao_rua ? "SIM" : "NÃO" }} </strong>
            </td>
          </tr>
          <tr>
            <td class="pt-2 border-0" v-if="pessoa.contato">
              <span>
                Contato:
                <strong> {{ pessoa.contato }} </strong>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
      <button
        type="button"
        class="close text-danger"
        @click="pessoa = null"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div
      v-if="membrosFamilia.length"
      class="alert alert-success alert-dismissible fade show shadow text-dark"
      role="alert"
    >
      <strong class="font-size-19">Membro(s) selecionado(s) para o atendimento</strong>
      <table class="mt-2 mb-0">
        <tbody>
        <tr>
          <td class="pr-3 pt-2 border-0" v-for="(membroFamilia, i) in membrosFamilia" :key="i">
            <strong>
              {{
                (membroFamilia?.nome_social)
                  ? membroFamilia?.nome_social
                  : membroFamilia?.nome_completo
              }}
            </strong>
            <b-link
              :to="'/dashboard/usuario/edit/' + membroFamilia.id"
              target="_blank"
              :title="$t('Ver Prontuário do usuário')"
              v-b-tooltip.hover
            >
              <i class="fas fa-external-link-alt"></i>
            </b-link>
            <span v-if="membroFamilia?.nome_social">
              <br />
              ( N.R.: )
              <template v-if="!showNameMembroFamilia[membroFamilia.id]">
                <a href="#" @click.prevent="toggleShowName(membroFamilia.id, true)">
                  <i class="fas fa-eye"></i>
                </a>
              </template>
              <template v-else>
                <span>
                  <strong>{{ membroFamilia?.nome_completo }}</strong>
                  <a href="#" @click.prevent="toggleShowName(membroFamilia.id, false)">
                    <i class="fas fa-eye-slash"></i>
                  </a>
                </span>
              </template>
            </span>
            <br />
            <small class="text-muted">
              Idade: {{ membroFamilia.idade }}
            </small>
          </td>
        </tr>
        </tbody>
      </table>
      <button
        type="button"
        class="close text-danger"
        @click="membrosFamilia = []"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="card shadow card-body tab-content rounded border">
      <b-tabs @input="onTabChange">
        <b-tab title="Agendamentos" active>
          <Agendamentos
            @pessoa-cadastrada="(pessoaCadastrada) => pessoa = pessoaCadastrada"
            @membros-familia-atendimento="(membrosFamiliaAtendimento) => membrosFamilia = membrosFamiliaAtendimento"
          />
        </b-tab>
        <b-tab title="Agenda Ativa" name="agendaAtiva">
          <AgendaAtiva :tab="tab"/>
        </b-tab>
        <b-tab title="Histórico de Agendamentos">
          <HistoricoAgendamentos :tab="tab"/>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import Agendamentos from "./pages/agendamentos/Agendamentos.vue"
import AgendaAtiva from "./pages/agenda_ativa/AgendaAtiva.vue";
import HistoricoAgendamentos from "./pages/historico_agendamentos/HistoricoAgendamentos.vue";

export default {
  name: "Atendimentos",
  components: {
    HistoricoAgendamentos,
    AgendaAtiva,
    Agendamentos,
  },
  data() {
    return {
      pessoa: null,
      showName: false,
      showNameMembroFamilia: {},
      membrosFamilia: [],
      tab: null
    }
  },
  methods: {
    toggleShowName(id, state) {
      this.$set(this.showNameMembroFamilia, id, state);
    },

    onTabChange(event) {
      switch (event) {
        case 0:
          this.tab = "agendamentos";
          break;
        case 1:
          this.tab = "agenda_ativa";
          break;
        case 2:
          this.tab = "historico_agendamentos";
          break;
      }
    }
  }
}
</script>
